var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import theme from "../../styles/theme";
var colors = theme.colors;
var User = function (_a) {
    var _b = _a.color, color = _b === void 0 ? colors.primary : _b, props = __rest(_a, ["color"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "m25 8.5c0 4.6945-4.0294 8.5-9 8.5s-9-3.8055-9-8.5c0-4.6945 4.0294-8.5 9-8.5s9 3.8055 9 8.5z", fill: color }),
        React.createElement("path", { d: "m26.286 21h-20.571c-3.1429 0-5.7143 2.475-5.7143 5.5s2.5714 5.5 5.7143 5.5h20.571c3.1429 0 5.7143-2.475 5.7143-5.5s-2.5714-5.5-5.7143-5.5z", fill: color })));
};
export default User;
//# sourceMappingURL=User.js.map